module.exports = __webpack_public_path__ + "images/application/signup-delivery@2x-5b083728.png";